/*
 *
 * TestContainer constants
 *
 */

export const DEFAULT_ACTION = 'app/TestContainer/DEFAULT_ACTION';

export const FLUSH_STATE = 'app/TestContainer/FLUSH_STATE';

// export const CHANGE_DATA = 'app/TestContainer/CHANGE_DATA';
// export const LOAD_VARIABLES = 'app/TestContainer/LOAD_VARIABLES';
// export const LOAD_VARIABLES_SUCCESS = 'app/TestContainer/LOAD_VARIABLES_SUCCESS';
// export const LOAD_VARIABLES_ERROR = 'app/TestContainer/LOAD_VARIABLES_ERROR';
